/**
 * Feature flags per environment
 *
 * Controls features that are enabled/disabled based on the build target.
 * Production-only features should be disabled in sandbox and vice-versa.
 */
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || '';
const isProd = projectId.includes('prod');

export const FEATURES = {
  // Banking Hub — disabled in production until Banco Central de Cabo Verde approval
  BANKING_HUB: !isProd,
  // PagaMe — disabled in production until ready
  PAGAME: !isProd,
};

export const IS_PROD = isProd;
export const IS_SANDBOX = !isProd;
